/** who helps people log in and reserve tickets: on the login page and under every e-mail */
export const HELP_CONTACT = {
	name: 'Arne Skorpe Sjøen',
	firstName: 'Arne',
	phone: '411 04 852',
	tel: '41104852',
	email: 'sjoen90@gmail.com',
} as const

/** "41104852" → "411 04 852", the way Norwegian mobile numbers are written */
export const formatPhone = (phone: string) => {
	const digits = phone.replace(/\D/g, '')
	return digits.length === 8
		? `${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5)}`
		: phone
}
